/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_HeadingInputs */

const tr_onbilgi_s11_heading = /** @type {(inputs: Onbilgi_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Uyumlu Donanım ve Yazılım Gereklilikleri`)
};

const en_onbilgi_s11_heading = /** @type {(inputs: Onbilgi_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Compatible Hardware and Software Requirements`)
};

const de_onbilgi_s11_heading = /** @type {(inputs: Onbilgi_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Kompatible Hardware- und Softwareanforderungen`)
};

const ru_onbilgi_s11_heading = /** @type {(inputs: Onbilgi_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Требования к совместимому оборудованию и программному обеспечению`)
};

/**
* | output |
* | --- |
* | "11. Compatible Hardware and Software Requirements" |
*
* @param {Onbilgi_S11_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_heading = /** @type {((inputs?: Onbilgi_S11_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_heading(inputs)
	if (locale === "de") return de_onbilgi_s11_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s11_heading(inputs)
	return tr_onbilgi_s11_heading(inputs)
});